import { AriApiQueryCreatorFetch } from './AriApiCreator';
import { prismScopes } from './auth';

const functionCode =
    '9e05VBSDjCS1oD8ZKlbtjzWiA0WzBMDhl14vjnDpkg6AzFuc7kq_g==';
/**
 * Initializes the `onBaseService` using a customized AriApiQueryCreatorFetch factory with specific `prismScopes` and an authorization function code.
 *
 * @param serviceURL - The service URL for the onBase API.
 * @param scopesObj - The scopes required for this service (prismScopes).
 * @param functionCode - The function code for auth/signing.
 * @returns An RTK Query service object containing hooks and endpoints for onBase data operations, specifically documenting details by handle.
 *
 * @example
 * onBaseService.endpoints.documentDetails.query({ docHandle: 123 }) // { url: '/GetDocument', params: { docHandle: 123 } }
 */
export const onBaseService = AriApiQueryCreatorFetch({
    serviceURL: 'https://ari-onbase-svc.azurewebsites.net/api',
    scopesObj: prismScopes,
    functionCode,
    apiOptions: {
        reducerPath: 'onBaseApi',
        endpoints: (builder) => ({
            documentDetails: builder.query<string, number>({
                query: (docHandle) => ({
                    url: '/GetDocument',
                    params: { docHandle }
                })
            })
        })
    }
});

export const { useLazyDocumentDetailsQuery } = onBaseService.hooks;
